module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/foreground_mobile-c62053caf264f08fa0089f03b6b4d3a0.png";